// extracted by mini-css-extract-plugin
module.exports = {"small":"Spacer_small__2PL3R","medium":"Spacer_medium__3xUfb","large":"Spacer_large__2Zy08","redSpacer":"Spacer_redSpacer__1CkFg","graySpacer":"Spacer_graySpacer__3HiYS"};